import { Category } from "./Category";

export interface User {
  _id?: string;
  email?: string;
  createdAt?: Date;
}
export interface Player {
  _id?: string;
  user?: User;
  schoolType?: SchoolType;
}

export interface SubcategoriesToResetDataModel {
  subcategoriesToReset: Array<ResetQuestionsHistoryRequestDataModel>;
}

export interface ResetQuestionsHistoryRequestDataModel {
  categoryId: string;
  subcategories: Array<string>;
}

export interface PlayerStatPerCategoryModel {
  numberOfSelection: number;
  category: Category;
}

export enum SchoolType {
  PRIMARY = "PrimarySchool",
  MIDDLE_AND_HIGH_SCHOOL = "MiddleAndHighSchool",
}
